$(document).ready(() => {
    $('input[name="profile_type"]').on('click', (evt) => {
        $radio = $(evt.target);
        if($radio.data('other')){
            $('input[name="profile_type_other"]').removeAttr('disabled');
        }else{
            $('input[name="profile_type_other"]').attr('disabled', 'disabled');
        }
    })

    $('input[name="account_type"]').on('click', (evt) => {
        $radio = $(evt.target);
        if($radio.data('other')){
            $('input[name="account_type_other"]').removeAttr('disabled');
        }else{
            $('input[name="account_type_other"]').attr('disabled', 'disabled');
        }
    })
});